import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Configuration } from '../domain/configuration';
import * as $ from 'jquery';
import { ReportDefinition } from '../domain/reportdefinition';
import { Router } from '@angular/router';
import { ReportDefinitionService } from '../service/reportdefinition.service';
import { CompanyService } from '../service/company.service';
import { Company } from '../domain/company';


@Component({
    selector: 'report-card',
    templateUrl: './report-card.component.html'
})

export class ReportCardComponent implements OnInit {
    constructor(
        private messageService: MessageService,
        private router: Router,
        private reportDefinitionService: ReportDefinitionService,
        private companyService: CompanyService
    ) {

    }

    @Input() Report : ReportDefinition;
    ReportImageHtmlWrapperId: string;
    ReportImageHtmlId: string;
    urlPicture : string;
    response: any;
    showPreviewLink: boolean = false;
    
    displayCopyToCompany: boolean;
    executingCopyToCompany: boolean = false;

    reportToCopy : ReportDefinition;
    companies: Company[];

    companyId: number;
     

    ngOnInit() {
        this.ReportImageHtmlWrapperId = 'reportImg' + this.Report.Id;
        this.ReportImageHtmlId = 'reportImg' + this.Report.Id + 'img';
        this.urlPicture = Configuration.server + '/api/report/' + this.Report.Id + '/image';
        this.GetImage(this.urlPicture);

        if (this.Report.ReportPreviewLink && this.Report.ReportPreviewLink.length > 0)
        {
            this.showPreviewLink = true;
        }

        this.companyService.get().then(objects => this.companies = objects).then(() => {

        });
    }

    previewReport(definition: ReportDefinition)
    {
        var openLink = !(definition.ReportPreviewLink.startsWith("http")) ? "http://" + definition.ReportPreviewLink : definition.ReportPreviewLink;

        var win = window.open(openLink, '_blank');
        win.focus();
    }

    public GetImage(url)
    {
        let token = localStorage.getItem('jwt');
        var htmlWrapperId = this.ReportImageHtmlWrapperId;
        var htmlId = this.ReportImageHtmlId;
        $.ajax({
            url: url,
            cache: false,
            beforeSend: function (xhr) { 
                xhr.setRequestHeader("Authorization", 'Bearer '+ token);
            },
            xhr:function(){// Seems like the only way to get access to the xhr object
                var xhr = new XMLHttpRequest();
                xhr.responseType= 'blob'
                return xhr;
            },
            success: function (response) {
                var urlCreator = window.URL;
                var imageUrl = urlCreator.createObjectURL(response);
                $('#' + htmlId).css('display', 'none');
                $('#' + htmlWrapperId).css('height', '180px').css('background-size', 'cover').css('background-position', 'center').css('background-image', 'url(' + imageUrl + ')');
            },
            error: function () {
                $('#' + htmlId).css('display', 'none');
                $('#' + htmlWrapperId).css('height', '180px').css('background-size', 'cover').css('background-position', 'center').css('background-image', "url('/assets/layout/images/report-image-placeholder.jpg')");
            }
        });
    }

    viewReportDefinition(definition: ReportDefinition) {
        this.router.navigate(['/reportdefinitions', definition.Id]);
    }

    duplicateReportDefinition(definition: ReportDefinition) {
        this.messageService.add({
            severity: 'info',
            summary: 'Started cloning ' + definition.Name,
            detail: 'Please wait...'
        });
        this.reportDefinitionService.clone(definition.Id)
            .then(newid => {
                setTimeout(function() {
                    location.reload();
                }, 2000);
            }
        );
    }

    copyToCompany(definition: ReportDefinition) {
        this.displayCopyToCompany = true;
        this.reportToCopy= definition;
       
    }
    copyToCompanyReportClick() {
        if (confirm(`Are you sure you want to copy report  "${this.reportToCopy.Name}"?`)) {
        this.displayCopyToCompany = true;
        this.messageService.add({
            severity: 'info',
            summary: 'Started cloning ' + this.reportToCopy.Name,
            detail: 'Please wait...'
        });
        this.reportDefinitionService.copy(this.reportToCopy.Id,this.companyId)
            .then(newid => {
                setTimeout(function() {
                    location.reload();
                }, 2000);
            }).catch(response => {
                console.log(response);
               
                this.displayCopyToCompany = true;
            });
        
        this.displayCopyToCompany = false;
        
        
        }
        
    }
    
    dataChanged(newObj) {
        console.log(newObj.value.id)
        this.companyId = newObj.value.id;
    }

    deleteReportDefinition(definition: ReportDefinition) {
        if (confirm(`Are you sure you want to delete report definition "${definition.Name}"?`)) {
            this.reportDefinitionService.delete(`${definition.Id}`).then(l => {
                this.messageService.add({
                    severity: 'info',
                    summary: 'ReportDefinition deleted',
                    detail: definition.Id + ' - ' + definition.Name
                });
                setTimeout(() => {
                    location.reload();
                }, 2000);
            });
        }
        else {
            alert("Delete action cancelled.")
        }
    }
}
